module.exports = {
  siteTitle: "Nick Dalalelis - Cloud Software Engineer", // <title>
  shortSiteTitle: "Nick Dalalelis - Cloud Software Engineer", // <title> ending for posts and pages
  siteDescription: "Nick Dalalelis is an experienced Cloud Software Engineer specializing in Big Data and Distributed Systems.",
  siteUrl: "https://www.nickthecloudguy.com",
  // pathPrefix: "",
  siteLanguage: "en",

  /* author */
  authorName: "Nick Dalalelis",
  authorTwitterAccount: "nickdalalelis",

  /* info */
  headerTitle: "Nick Dalalelis",
  headerSubTitle: "Cloud Software Engineer",

  /* manifest.json */
  manifestName: "Nick Dalalelis - Cloud Software Engineer",
  manifestShortName: "nickdala", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/nickdala" },
    { name: "twitter", url: "https://twitter.com/nickdalalelis" }
  ]
};
